export const ALL_ACCOUNTS_ID = 0;
export const ALL_ACCOUNTS_NAME = "All Accounts";
